import { SET_PAGE, UPDATE_PAGE } from '../mutation-types';

export default {
    state: () => ({
        page: null
    }),
    mutations: {
        [SET_PAGE](state, page) {
            state.page = page;
        },
        [UPDATE_PAGE](state, data) {
            state.page = Object.assign({}, state.page || {}, data);
        }
    },
    getters: {
        siteId: state => {
            return state.page && state.page.siteId;
        }
    }
};
